module.exports = __webpack_public_path__ + "static/richard-pitt-640a6d6f8b20e6ee1eedc6b72a3934e2.jpg";